import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  Stack,
  Divider,
  IconButton,
  Card,
  CardContent,
  Alert,
  Chip,
  CircularProgress,
  alpha,
  useTheme,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Badge,
  Snackbar,
  Tooltip,
  Avatar,
  Tabs,
  Tab,
  CardActionArea,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  useMediaQuery,
  tooltipClasses,
} from "@mui/material";
import {
  AutoStories,
  FormatListBulleted,
  Lightbulb,
  ContentCopy,
  Download,
  Save,
  Language,
  EditNote,
  Palette,
  DesignServices,
  Dashboard,
  RocketLaunch,
  Share,
  Close,
  Fullscreen,
  Visibility,
  Delete,
  History,
  Psychology,
  LocalLibrary,
  SmartToy,
  AccessTime,
  Category,
  TextFields,
  Description,
  Image,
  Summarize,
  ViewList,
  PostAdd,
  Refresh,
  ClearAll,
  AutoAwesome,
  AutoFixHigh,
} from "@mui/icons-material";
import Poetlogopen from "../static/POET_Logo_Pen.png";
import { styled } from "@mui/material/styles";
import MuiAlert from "@mui/material/Alert";
import { Breadcrumbs, Link } from "@mui/material";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { Home, ChevronRight } from "@mui/icons-material";
import newBlogService from "../services/new_blogsServices";
import Loader from "../utils/loader";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";


const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "zIndex",
          enabled: true,
          phase: "write",
          fn: ({ state }) => {
            state.styles.popper.zIndex = 99999;
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.common.white,
    boxShadow: theme.shadows[6],
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 10,
    padding: "8px 14px",
    backdropFilter: "blur(6px)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
  },
}));
// Modern Loading Overlay Component
const ModernLoadingOverlay = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          theme.palette.mode === "dark"
            ? `linear-gradient(135deg, ${alpha("#0f172a", 0.95)} 0%, ${alpha("#1e293b", 0.95)} 100%)`
            : `linear-gradient(135deg, ${alpha("#f8fafc", 0.95)} 0%, ${alpha("#f1f5f9", 0.95)} 100%)`,
        backdropFilter: "blur(10px)",
      }}
    >
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        {/* Animated Gradient Background */}
        <Grid xs={12}>
          <Box
            sx={{
              position: "relative",
              width: 280,
              height: 280,
              margin: "0 auto",
              borderRadius: "50%",
              background:
                "linear-gradient(45deg, #4A90E2, #9C27B0, #FF6B35, #44AF69)",
              backgroundSize: "400% 400%",
              animation: "gradientShift 3s ease infinite",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:before": {
                content: '""',
                position: "absolute",
                inset: 10,
                borderRadius: "50%",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #0f172a, #1e293b)"
                    : "linear-gradient(135deg, #ffffff, #f8fafc)",
                zIndex: 1,
              },
              "@keyframes gradientShift": {
                "0%": { backgroundPosition: "0% 50%" },
                "50%": { backgroundPosition: "100% 50%" },
                "100%": { backgroundPosition: "0% 50%" },
              },
            }}
          >
            {/* Main Spinner */}
            <Box
              sx={{
                position: "relative",
                zIndex: 2,
                textAlign: "center",
              }}
            >
              {/* Outer Rotating Ring */}
              <CircularProgress
                size={120}
                thickness={2}
                sx={{
                  color: "transparent",
                  background:
                    "conic-gradient(from 0deg, transparent 0%, #4A90E2 25%, #9C27B0 50%, #FF6B35 75%, transparent 100%)",
                  borderRadius: "50%",
                  animation: "rotate 2s linear infinite",
                  "@keyframes rotate": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />

              {/* Inner Pulsing Circle */}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, #1e293b, #334155)"
                      : "linear-gradient(135deg, #ffffff, #f1f5f9)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                  animation: "pulse 1.5s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%, 100%": { transform: "translate(-50%, -50%) scale(1)" },
                    "50%": { transform: "translate(-50%, -50%) scale(1.05)" },
                  },
                }}
              >
                <AutoStories
                  sx={{
                    fontSize: 28,
                    color: "primary.main",
                    animation: "float 2s ease-in-out infinite",
                    "@keyframes float": {
                      "0%, 100%": { transform: "translateY(0px)" },
                      "50%": { transform: "translateY(-5px)" },
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Loading Text with Dots Animation */}
        <Grid xs={12}>
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #60a5fa, #a78bfa)"
                    : "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                mb: 1,
              }}
            >
              Crafting Your Book
              <Box
                component="span"
                sx={{
                  "&::after": {
                    content: '""',
                    animation: "dots 1.5s steps(4, end) infinite",
                    "@keyframes dots": {
                      "0%, 20%": { content: '""' },
                      "40%": { content: '"."' },
                      "60%": { content: '".."' },
                      "80%, 100%": { content: '"..."' },
                    },
                  },
                }}
              />
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                maxWidth: 400,
                mx: "auto",
                mb: 3,
              }}
            >
              AI is generating your content. This may take a few moments...
            </Typography>

            {/* Progress Indicators */}
            <Grid container spacing={2} justifyContent="center">
              {["Ideation", "Structure", "Content", "Refinement"].map(
                (step, index) => (
                  <Grid key={step}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        opacity: 0.3,
                        animation: `stepPulse ${2 + index * 0.5}s ease-in-out infinite`,
                        "@keyframes stepPulse": {
                          "0%, 100%": { opacity: 0.3 },
                          "50%": { opacity: 1 },
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          bgcolor: ["#FF6B35", "#4A90E2", "#44AF69", "#9C27B0"][
                            index
                          ],
                          mb: 0.5,
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 500,
                          color: "text.secondary",
                        }}
                      >
                        {step}
                      </Typography>
                    </Box>
                  </Grid>
                ),
              )}
            </Grid>
          </Box>
        </Grid>

        {/* Decorative Elements */}
        <Grid xs={12}>
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}
          >
            {[1, 2, 3, 4].map((i) => (
              <Box
                key={i}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  background: `conic-gradient(from ${i * 90}deg, transparent, ${alpha("#4A90E2", 0.3)})`,
                  animation: `floatCircle ${3 + i * 0.5}s ease-in-out infinite`,
                  "@keyframes floatCircle": {
                    "0%, 100%": {
                      transform: `translateY(0px) rotate(${i * 90}deg)`,
                      opacity: 0.3,
                    },
                    "50%": {
                      transform: `translateY(-20px) rotate(${i * 90 + 180}deg)`,
                      opacity: 0.7,
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const AIBookWriting = () => {
  const [activeGenerator, setActiveGenerator] = useState("idea");
  const [language, setLanguage] = useState("english");
  const [bookType, setBookType] = useState("");
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [generatorLoading, setGeneratorLoading] = useState(null);
  const [generatedContent, setGeneratedContent] = useState("");
  const [editedContent, setEditedContent] = useState("");
  const [formattedContent, setFormattedContent] = useState(null);
  const [savedContents, setSavedContents] = useState([]);
  const [openContentDialog, setOpenContentDialog] = useState(false);
  const [openSavedDialog, setOpenSavedDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const history = useHistory();

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };

  const getContent = (res) => res?.data?.content || null;

  useEffect(() => {
    const saved = localStorage.getItem("aiBookSavedContents");
    if (saved) {
      setSavedContents(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("aiBookSavedContents", JSON.stringify(savedContents));
  }, [savedContents]);

  useEffect(() => {
    setEditedContent(generatedContent);
    if (generatedContent) {
      const formatted = formatGeneratedContent(generatedContent);
      setFormattedContent(formatted);
    } else {
      setFormattedContent(null);
    }
  }, [generatedContent, activeGenerator]);

  const validateForm = () => {
    switch (activeGenerator) {
      case "idea":
        return formData.bookAbout && bookType && formData.category;
      case "outline":
        return formData.title && formData.chapters && bookType;
      case "cover":
        return (
          formData.title && formData.author && formData.summary && bookType
        );
      case "summary":
        return formData.bookAbout && bookType;
      default:
        return false;
    }
  };

  const getValidationMessage = () => {
    switch (activeGenerator) {
      case "idea":
        return "Please fill: Book About, Genre, and Category";
      case "outline":
        return "Please fill: Book Title, Chapters, and Genre";
      case "cover":
        return "Please fill: Book Title, Author, Summary, and Genre";
      case "summary":
        return "Please fill: Book Content and Genre";
      default:
        return "Please fill all required fields!";
    }
  };

  const formatGeneratedContent = (content) => {
    if (!content) return null;

    const lines = content.split("\n");
    const formattedLines = [];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (!line) {
        formattedLines.push(<br key={`br-${i}`} />);
        continue;
      }

      if (
        line.endsWith(":") ||
        /^[A-Z][A-Za-z\s]*:$/.test(line) ||
        line.toLowerCase().includes("chapter") ||
        line.toLowerCase().includes("part") ||
        line.toLowerCase().includes("act") ||
        line.toLowerCase().includes("section") ||
        line.toLowerCase().includes("title:") ||
        /^[IVXLCDM]+\./.test(line) ||
        /^\d+\.\s/.test(line)
      ) {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        const textWithoutEmojis = line
          .replace(
            /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
            "",
          )
          .trim();

        formattedLines.push(
          <Box key={`title-${i}`} sx={{ mt: i > 0 ? 3 : 0, mb: 1.5 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                color: generators.find((g) => g.id === activeGenerator)?.color,
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: "1.1rem",
                background: alpha(
                  generators.find((g) => g.id === activeGenerator)?.color,
                  0.08,
                ),
                p: 1.5,
                borderRadius: 2,
                borderLeft: `4px solid ${generators.find((g) => g.id === activeGenerator)?.color}`,
              }}
            >
              {emojis && <span style={{ fontSize: "1.2em" }}>{emojis}</span>}
              <span>{textWithoutEmojis}</span>
            </Typography>
          </Box>,
        );
      }
      // Detect bullet points or numbered items
      else if (
        line.startsWith("-") ||
        line.startsWith("•") ||
        line.startsWith("*") ||
        /^\d+\.\s/.test(line)
      ) {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        let text = line;

        // Remove bullet markers but keep emojis
        text = text.replace(/^[-•*]\s*/, "").replace(/^\d+\.\s*/, "");

        formattedLines.push(
          <Box
            key={`list-${i}`}
            sx={{ display: "flex", alignItems: "flex-start", mb: 1, ml: 2 }}
          >
            <Typography
              component="span"
              sx={{
                mr: 1.5,
                color: generators.find((g) => g.id === activeGenerator)?.color,
                fontWeight: 600,
              }}
            >
              •
            </Typography>
            <Typography component="span" sx={{ flex: 1, lineHeight: 1.6 }}>
              {emojis && (
                <span style={{ marginRight: 6, fontSize: "1.1em" }}>
                  {emojis}
                </span>
              )}
              {formatBoldText(text)}
            </Typography>
          </Box>,
        );
      }
      // Detect bold text within **text** or __text__
      else if (line.includes("**") || line.includes("__")) {
        formattedLines.push(
          <Typography
            key={`bold-line-${i}`}
            paragraph
            sx={{ mb: 1.5, lineHeight: 1.7 }}
          >
            {formatBoldText(line)}
          </Typography>,
        );
      }
      // Regular paragraphs with emoji support
      else {
        const emojiMatch = line.match(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
        );
        const emojis = emojiMatch ? emojiMatch.join(" ") : "";
        const textWithoutEmojis = line
          .replace(
            /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu,
            "",
          )
          .trim();

        formattedLines.push(
          <Typography
            key={`para-${i}`}
            paragraph
            sx={{
              mb: 1.5,
              lineHeight: 1.7,
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
            }}
          >
            {emojis && (
              <span style={{ fontSize: "1.1em", lineHeight: 1, flexShrink: 0 }}>
                {emojis}
              </span>
            )}
            <span>{formatBoldText(textWithoutEmojis)}</span>
          </Typography>,
        );
      }
    }

    return formattedLines;
  };

  // Helper function to format bold text
  const formatBoldText = (text) => {
    if (!text) return text;

    const parts = [];
    let currentIndex = 0;
    const boldRegex = /(\*\*|__)(.*?)\1/g;
    let match;

    while ((match = boldRegex.exec(text)) !== null) {
      if (match.index > currentIndex) {
        parts.push(text.substring(currentIndex, match.index));
      }
      parts.push(
        <Box
          component="span"
          key={`bold-${currentIndex}`}
          sx={{
            fontWeight: 700,
            color: generators.find((g) => g.id === activeGenerator)?.color,
            backgroundColor: alpha(
              generators.find((g) => g.id === activeGenerator)?.color,
              0.1,
            ),
            px: 0.8,
            py: 0.2,
            borderRadius: 1,
            mx: 0.3,
          }}
        >
          {match[2]}
        </Box>,
      );

      currentIndex = match.index + match[0].length;
    }

    if (currentIndex < text.length) {
      parts.push(text.substring(currentIndex));
    }

    if (parts.length === 0) {
      return text;
    }

    return parts;
  };

  const generators = [
    {
      id: "idea",
      label: "Book Ideas",
      description: "Generate unique book concepts",
      icon: <Lightbulb />,
      color: "#FF6B35",
      gradient: "linear-gradient(135deg, #FF6B35, #FFA62E)",
      bgColor: "rgba(255, 107, 53, 0.1)",
    },
    {
      id: "outline",
      label: "Book Outline",
      description: "Create chapter structures",
      icon: <FormatListBulleted />,
      color: "#4A90E2",
      gradient: "linear-gradient(135deg, #4A90E2, #357ABD)",
      bgColor: "rgba(74, 144, 226, 0.1)",
    },
    {
      id: "cover",
      label: "Cover Ideas",
      description: "Design book cover concepts",
      icon: <Palette />,
      color: "#44AF69",
      gradient: "linear-gradient(135deg, #44AF69, #2E8B57)",
      bgColor: "rgba(68, 175, 105, 0.1)",
    },
    {
      id: "summary",
      label: "Book Summary",
      description: "Craft summaries and synopses",
      icon: <DesignServices />,
      color: "#9C27B0",
      gradient: "linear-gradient(135deg, #9C27B0, #7B1FA2)",
      bgColor: "rgba(156, 39, 176, 0.1)",
    },
  ];

  const languages = [
    { value: "english", label: "English", flag: "🇺🇸" },
    { value: "tamil", label: "Tamil", flag: "🇮🇳" },
    { value: "arabic", label: "Arabic", flag: "🇸🇦" },
    { value: "spanish", label: "Spanish", flag: "🇪🇸" },
    { value: "french", label: "French", flag: "🇫🇷" },
    { value: "german", label: "German", flag: "🇩🇪" },
  ];

  const bookTypesData = [
    { value: "fantasy", label: "Fantasy", icon: "🧙‍♂️" },
    { value: "scifi", label: "Sci-Fi", icon: "🚀" },
    { value: "romance", label: "Romance", icon: "❤️" },
    { value: "mystery", label: "Mystery", icon: "🕵️" },
    { value: "thriller", label: "Thriller", icon: "🔪" },
    { value: "horror", label: "Horror", icon: "👻" },
    { value: "historical", label: "Historical", icon: "🏛️" },
    { value: "biography", label: "Biography", icon: "📖" },
  ];

  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  // API functions
  const generateBookIdeaFromAPI = async () => {
    if (!formData.bookAbout || !bookType || !formData.category) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("idea");
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        category: formData.category,
        book_about: formData.bookAbout,
        tone: "Creative",
      };

      const res = await newBlogService.generateBookIdea(payload);
      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error",
        );
        return;
      }

      setGeneratedContent(content);
      showNotification("Book idea generated successfully!", "success");
    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book idea", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null);
    }
  };

  const generateBookCoverFromAPI = async () => {
    if (!formData.title || !formData.author || !formData.summary || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("cover");
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        chapters: formData.chapters || "12",
        book_title: formData.title,
        author_name: formData.author,
        subtitle: formData.subtitle || "",
        brief_summary: formData.summary,
        tone: "Creative",
      };

      const res = await newBlogService.generateBookCoverIdeas(payload);
      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error",
        );
        return;
      }

      setGeneratedContent(content);
      showNotification("Book cover ideas generated successfully!", "success");
    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book cover ideas", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null);
    }
  };

  const generateBookOutlineFromAPI = async () => {
    if (!formData.title || !formData.chapters || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("outline");
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        chapters: formData.chapters,
        book_title: formData.title,
        target_audience: formData.audience || "General readers",
        tone: "Creative",
      };

      const res = await newBlogService.generateBookOutline(payload);
      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error",
        );
        return;
      }

      setGeneratedContent(content);
      showNotification("Book outline generated successfully!", "success");
    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book outline", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null);
    }
  };

  const generateBookSummaryFromAPI = async () => {
    if (!formData.bookAbout || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("summary");
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        book_about: formData.bookAbout,
        tone_of_writing: formData.tone || "Dramatic",
      };

      const res = await newBlogService.generateBookSummary(payload);
      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error",
        );
        return;
      }

      setGeneratedContent(content);
      showNotification("Book summary generated successfully!", "success");
    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book summary", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null);
    }
  };

  const handleGenerate = async (e) => {
    if (e) e.preventDefault();

    if (activeGenerator === "idea") {
      await generateBookIdeaFromAPI();
    } else if (activeGenerator === "outline") {
      await generateBookOutlineFromAPI();
    } else if (activeGenerator === "cover") {
      await generateBookCoverFromAPI();
    } else if (activeGenerator === "summary") {
      await generateBookSummaryFromAPI();
    } else {
      showNotification("API not connected for this generator yet", "info");
    }
  };

  // NEW PROJECT FUNCTIONALITY
  const handleNewProject = () => {
    setActiveGenerator("idea");
    setFormData({});
    setGeneratedContent("");
    setEditedContent("");
    setFormattedContent(null);
    setBookType("");
    setLanguage("english");
    showNotification("Started new project!", "info");
  };

  // CLEAR ALL FUNCTIONALITY
  const handleClearAll = () => {
    setFormData({});
    setGeneratedContent("");
    setEditedContent("");
    setFormattedContent(null);
    showNotification("All fields cleared!", "info");
  };

  const handleSave = () => {
    if (!editedContent.trim()) {
      showNotification("No content to save!", "warning");
      return;
    }

    const newContent = {
      id: Date.now(),
      title:
        generators.find((g) => g.id === activeGenerator)?.label || "Untitled",
      content: editedContent,
      formattedContent: formattedContent,
      generator: activeGenerator,
      language,
      genre: bookType,
      timestamp: new Date().toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
      preview: editedContent.substring(0, 80) + "...",
      color: generators.find((g) => g.id === activeGenerator)?.color,
    };

    const updatedContents = [newContent, ...savedContents];
    setSavedContents(updatedContents);
    showNotification("Content saved successfully!", "success");
  };

  const handleCopy = () => {
    if (!editedContent.trim()) {
      showNotification("No content to copy!", "warning");
      return;
    }

    navigator.clipboard
      .writeText(editedContent)
      .then(() => showNotification("Content copied to clipboard!", "success"))
      .catch(() => showNotification("Failed to copy content!", "error"));
  };

  const handleDownload = () => {
    if (!editedContent.trim()) {
      showNotification("No content to download!", "warning");
      return;
    }

    const element = document.createElement("a");
    const file = new Blob([editedContent], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `ai-book-${activeGenerator}-${Date.now()}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    showNotification("Content downloaded!", "success");
  };

  // VIEW SAVED CONTENT FUNCTIONALITY
  const handleViewSaved = (content) => {
    setGeneratedContent(content.content);
    setEditedContent(content.content);
    setFormattedContent(
      content.formattedContent || formatGeneratedContent(content.content),
    );
    setOpenSavedDialog(false);
    // Set the active generator and form data from saved content
    setActiveGenerator(content.generator);
    setLanguage(content.language);
    setBookType(content.genre);
    showNotification("Content loaded from saved items!", "info");
  };

  const handleDeleteSaved = (id) => {
    const updatedContents = savedContents.filter(
      (content) => content.id !== id,
    );
    setSavedContents(updatedContents);
    showNotification("Content deleted!", "success");
  };

  const handleFormChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleGeneratorClick = (generatorId) => {
    setActiveGenerator(generatorId);
    setFormData({});
    setGeneratedContent("");
    setEditedContent("");
    setFormattedContent(null);
  };

  const getGeneratorIcon = (generatorId) => {
    switch (generatorId) {
      case "idea":
        return <Lightbulb />;
      case "outline":
        return <FormatListBulleted />;
      case "cover":
        return <Palette />;
      case "summary":
        return <DesignServices />;
      default:
        return <AutoStories />;
    }
  };

  const renderFormFields = () => {
    const currentGenerator = generators.find((g) => g.id === activeGenerator);

    switch (activeGenerator) {
      case "idea":
        return (
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Card
                sx={{
                  border: `2px solid ${alpha(currentGenerator.color, 0.2)}`,
                  background: alpha(currentGenerator.color, 0.05),
                  borderRadius: 3,
                  mb: 2,
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        background: currentGenerator.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Lightbulb sx={{ color: "white", fontSize: 24 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Book Idea Generator
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Generate unique book concepts based on your preferences
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="What is your book about?"
                placeholder="Describe your book idea, theme, or inspiration..."
                multiline
                rows={3}
                value={formData.bookAbout || ""}
                onChange={handleFormChange("bookAbout")}
                required
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    background: alpha(theme.palette.background.paper, 0.8),
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Description sx={{ mr: 1, color: "text.secondary" }} />
                  ),
                }}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={formData.category || ""}
                  label="Category"
                  onChange={handleFormChange("category")}
                  required
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="fiction">📚 Fiction</MenuItem>
                  <MenuItem value="non-fiction">📊 Non-Fiction</MenuItem>
                  <MenuItem value="poetry">🎭 Poetry</MenuItem>
                  <MenuItem value="academic">🎓 Academic</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Target Word Count"
                type="number"
                value={formData.wordCount || ""}
                onChange={handleFormChange("wordCount")}
                InputProps={{
                  endAdornment: (
                    <Typography variant="caption" sx={{ mr: 1 }}>
                      words
                    </Typography>
                  ),
                }}
                sx={{ borderRadius: 2 }}
              />
            </Grid>
          </Grid>
        );

      case "outline":
        return (
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Card
                sx={{
                  border: `2px solid ${alpha(currentGenerator.color, 0.2)}`,
                  background: alpha(currentGenerator.color, 0.05),
                  borderRadius: 3,
                  mb: 2,
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        background: currentGenerator.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ViewList sx={{ color: "white", fontSize: 24 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Book Outline Generator
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Create detailed chapter structures and plot outlines
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Book Title"
                value={formData.title || ""}
                onChange={handleFormChange("title")}
                required
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>
            <Grid xs={12} md={3}>
              <TextField
                fullWidth
                type="number"
                label="Chapters"
                value={formData.chapters || ""}
                onChange={handleFormChange("chapters")}
                InputProps={{
                  inputProps: { min: 1, max: 50 },
                }}
                required
              />
            </Grid>
            <Grid xs={12} md={3}>
              <TextField
                fullWidth
                label="Target Audience"
                value={formData.audience || ""}
                onChange={handleFormChange("audience")}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Plot Summary (Optional)"
                multiline
                rows={2}
                value={formData.plot || ""}
                onChange={handleFormChange("plot")}
                placeholder="Brief plot summary for better outline generation..."
              />
            </Grid>
          </Grid>
        );

      case "cover":
        return (
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Card
                sx={{
                  border: `2px solid ${alpha(currentGenerator.color, 0.2)}`,
                  background: alpha(currentGenerator.color, 0.05),
                  borderRadius: 3,
                  mb: 2,
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        background: currentGenerator.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Image sx={{ color: "white", fontSize: 24 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Book Cover Ideas Generator
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Create stunning book cover concepts and design ideas
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Author's Name"
                value={formData.author || ""}
                onChange={handleFormChange("author")}
                required
              />
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Book Title"
                value={formData.title || ""}
                onChange={handleFormChange("title")}
                required
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Subtitle (Optional)"
                value={formData.subtitle || ""}
                onChange={handleFormChange("subtitle")}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Brief Summary"
                multiline
                rows={3}
                value={formData.summary || ""}
                onChange={handleFormChange("summary")}
                required
                placeholder="Provide a brief summary for cover concept inspiration..."
              />
            </Grid>
          </Grid>
        );

      case "summary":
        return (
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Card
                sx={{
                  border: `2px solid ${alpha(currentGenerator.color, 0.2)}`,
                  background: alpha(currentGenerator.color, 0.05),
                  borderRadius: 3,
                  mb: 2,
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        background: currentGenerator.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Summarize sx={{ color: "white", fontSize: 24 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Book Summary Generator
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Craft compelling summaries and synopses for your book
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Book Content"
                placeholder="Describe your book's main content, characters, and plot..."
                multiline
                rows={4}
                value={formData.bookAbout || ""}
                onChange={handleFormChange("bookAbout")}
                required
              />
            </Grid>
            <Grid xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Tone of Writing</InputLabel>
                <Select
                  value={formData.tone || ""}
                  label="Tone of Writing"
                  onChange={handleFormChange("tone")}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="formal">🎩 Formal</MenuItem>
                  <MenuItem value="casual">😊 Casual</MenuItem>
                  <MenuItem value="humorous">😂 Humorous</MenuItem>
                  <MenuItem value="dramatic">🎭 Dramatic</MenuItem>
                  <MenuItem value="poetic">📜 Poetic</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Summary Length"
                select
                value={formData.length || "medium"}
                onChange={handleFormChange("length")}
              >
                <MenuItem value="short">Short (1-2 paragraphs)</MenuItem>
                <MenuItem value="medium">Medium (3-4 paragraphs)</MenuItem>
                <MenuItem value="detailed">Detailed (5+ paragraphs)</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
            : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        py: 3,
        position: "relative",
      }}
    >
      {/* Modern Loading Overlay */}
      {loading && <ModernLoadingOverlay />}

      <Container maxWidth="xl" sx={{ py: 2 }}>
        {/* Modern Breadcrumb */}
        <Box sx={{ mb: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: 3,
              backgroundColor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                px: 1,
                textShadow: "0 0 10px rgba(192,144,255,0.6)",
              }}
            >
              <Box
                sx={{
                  bgcolor: "white",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  mr: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  alt="logo"
                  src={Poetlogopen}
                  style={{
                    height: "28px",
                    width: "28px",
                    objectFit: "contain",
                    bgcolor: 'white',
                    // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
                    filter: "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                  }}
                />
              </Box>
              <Breadcrumbs
                separator={
                  <NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />
                }
                aria-label="breadcrumb"
              >
                {/* First breadcrumb item */}
                <Box
                  component={RouterLink}
                  to="/docTags"
                  onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                  sx={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    color: "#667eea",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(102, 126, 234, 0.08)",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "rgba(102, 126, 234, 0.12)",
                      color: "#764ba2",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <AutoFixHigh sx={{ fontSize: 20, mr: 1 }} />
                  MultiTool AI
                </Box>

                {/* Current page */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(102, 126, 234, 0.08)",
                  }}
                >
                  <AutoAwesome sx={{ fontSize: 20, color: "#667eea", mr: 1 }} />
                  <Typography
                    sx={{
                      color: "#1a1a1a",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                    }}
                  >
                    AI Book Writing Tool
                  </Typography>
                </Box>
              </Breadcrumbs>
            </Box>
          </Paper>
        </Box>

        {/* Main Header with Updated Title */}
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              background:
                theme.palette.mode === "dark"
                  ? "linear-gradient(135deg, #60a5fa, #a78bfa)"
                  : "linear-gradient(135deg, #3b82f6, #8b5cf6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              mb: 1,
              fontSize: { xs: "2rem", md: "3rem" },
            }}
          >
            AI Book Writing Tool
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "text.secondary",
              fontWeight: 400,
              mb: 3,
              maxWidth: "800px",
              mx: "auto",
            }}
          >
            Transform your ideas into compelling stories with advanced AI
            assistance
          </Typography>
        </Box>

        {/* Main Content Area */}
        <Grid container spacing={3}>
          {/* Left Sidebar - Generator Selection */}
          <Grid xs={12} md={3} lg={2.5}>
            <Paper
              sx={{
                p: 3,
                borderRadius: 3,
                height: "fit-content",
                position: "sticky",
                top: 24,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #1e293b, #0f172a)"
                    : "linear-gradient(135deg, #ffffff, #f8fafc)",
                boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 3,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  color: "text.primary",
                }}
              >
                <Dashboard sx={{ color: "primary.main" }} />
                AI Tools
              </Typography>

              <Stack spacing={2}>
                {generators.map((gen) => (
                  <CardActionArea
                    key={gen.id}
                    onClick={() => handleGeneratorClick(gen.id)}
                    sx={{
                      borderRadius: 2.5,
                      overflow: "hidden",
                      position: "relative",
                      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                      border:
                        activeGenerator === gen.id
                          ? `2px solid ${gen.color}`
                          : `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                      background:
                        activeGenerator === gen.id
                          ? alpha(gen.color, 0.08)
                          : "transparent",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: `0 6px 20px ${alpha(gen.color, 0.15)}`,
                        borderColor: gen.color,
                      },
                    }}
                  >
                    <CardContent sx={{ p: 2 }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Box
                          sx={{
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            background: gen.gradient,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            flexShrink: 0,
                          }}
                        >
                          {gen.icon}
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            sx={{
                              color:
                                activeGenerator === gen.id
                                  ? gen.color
                                  : "text.primary",
                            }}
                          >
                            {gen.label}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {gen.description}
                          </Typography>
                        </Box>
                        {generatorLoading === gen.id && (
                          <CircularProgress
                            size={18}
                            sx={{ color: gen.color, flexShrink: 0 }}
                          />
                        )}
                      </Stack>
                    </CardContent>
                  </CardActionArea>
                ))}
              </Stack>

              {/* Stats Section */}
              <Box
                sx={{
                  mt: 4,
                  pt: 3,
                  borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  gutterBottom
                  color="text.secondary"
                >
                  Quick Stats
                </Typography>
                <Stack spacing={1.5}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="caption" color="text.secondary">
                      Saved Projects
                    </Typography>
                    <Chip
                      label={savedContents.length}
                      size="small"
                      sx={{
                        height: 20,
                        fontSize: "0.7rem",
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                      }}
                    />
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="caption" color="text.secondary">
                      AI Tools
                    </Typography>
                    <Typography variant="caption" fontWeight={600}>
                      {generators.length}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="caption" color="text.secondary">
                      Languages
                    </Typography>
                    <Typography variant="caption" fontWeight={600}>
                      {languages.length}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            </Paper>
          </Grid>

          {/* Main Content - Form and Editor */}
          <Grid xs={12} md={9} lg={9.5}>
            <Paper
              sx={{
                p: { xs: 2, md: 4 },
                borderRadius: 3,
                minHeight: "calc(100vh - 180px)",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #1e293b, #0f172a)"
                    : "linear-gradient(135deg, #ffffff, #f8fafc)",
                boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                position: "relative",
              }}
            >
              {/* Generator Header */}
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid xs={12} md={8}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 52,
                          height: 52,
                          borderRadius: 2.5,
                          background: generators.find(
                            (g) => g.id === activeGenerator,
                          )?.gradient,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          flexShrink: 0,
                        }}
                      >
                        {generators.find((g) => g.id === activeGenerator)?.icon}
                      </Box>
                      <Box>
                        <Typography variant="h5" fontWeight={700}>
                          {
                            generators.find((g) => g.id === activeGenerator)
                              ?.label
                          }
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {
                            generators.find((g) => g.id === activeGenerator)
                              ?.description
                          }
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid xs={12} md={4}>
                    <Stack
                      direction="row"
                      spacing={1.5}
                      justifyContent={{ xs: "flex-start", md: "flex-end" }}
                      flexWrap="wrap"
                      gap={1.5}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => setOpenSavedDialog(true)}
                        startIcon={<History />}
                        size={isMobile ? "small" : "medium"}
                        sx={{ borderRadius: 2 }}
                      >
                        <Badge
                          badgeContent={savedContents.length}
                          color="primary"
                          sx={{ "& .MuiBadge-badge": { fontSize: 10 } }}
                        >
                          Saved
                        </Badge>
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          if (!validateForm()) {
                            showNotification(getValidationMessage(), "warning");
                            return;
                          }
                          setOpenContentDialog(false);
                          setTimeout(() => {
                            handleGenerate();
                          }, 100);
                        }}
                        disabled={loading}
                        startIcon={<RocketLaunch />}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, #4A90E2, #357ABD)",
                          boxShadow: "0 4px 16px rgba(74, 144, 226, 0.25)",
                          "&:hover": {
                            boxShadow: "0 6px 24px rgba(74, 144, 226, 0.35)",
                            background:
                              "linear-gradient(135deg, #357ABD, #2C6CB0)",
                          },
                        }}
                      >
                        {loading ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Generate"
                        )}
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              {/* Settings Bar */}
              <Paper
                sx={{
                  p: 2.5,
                  mb: 4,
                  borderRadius: 2.5,
                  background: alpha(theme.palette.background.paper, 0.6),
                  border: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
                  backdropFilter: "blur(10px)",
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid xs={12} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Language sx={{ fontSize: 18 }} />
                          <Typography variant="body2">Language</Typography>
                        </Stack>
                      </InputLabel>
                      <Select
                        value={language}
                        label="Language"
                        onChange={(e) => setLanguage(e.target.value)}
                        sx={{ borderRadius: 2 }}
                      >
                        {languages.map((lang) => (
                          <MenuItem key={lang.value} value={lang.value}>
                            <Stack
                              direction="row"
                              spacing={1.5}
                              alignItems="center"
                            >
                              <Typography sx={{ fontSize: "1.1rem" }}>
                                {lang.flag}
                              </Typography>
                              <Typography variant="body2">
                                {lang.label}
                              </Typography>
                            </Stack>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <LocalLibrary sx={{ fontSize: 18 }} />
                          <Typography variant="body2">Genre</Typography>
                        </Stack>
                      </InputLabel>
                      <Select
                        value={bookType}
                        label="Genre"
                        onChange={(e) => setBookType(e.target.value)}
                        sx={{ borderRadius: 2 }}
                      >
                        <MenuItem value="">
                          <em>Select Genre</em>
                        </MenuItem>
                        {bookTypesData.map((type) => (
                          <MenuItem key={type.value} value={type.value}>
                            <Stack
                              direction="row"
                              spacing={1.5}
                              alignItems="center"
                            >
                              <Typography sx={{ fontSize: "1.1rem" }}>
                                {type.icon}
                              </Typography>
                              <Typography variant="body2">
                                {type.label}
                              </Typography>
                            </Stack>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Project Name"
                      placeholder="My Book Project..."
                      sx={{ borderRadius: 2 }}
                      InputProps={{
                        startAdornment: (
                          <EditNote
                            sx={{
                              mr: 1,
                              color: "text.secondary",
                              fontSize: 18,
                            }}
                          />
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>

              {/* Generator Form */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  gutterBottom
                  sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <EditNote sx={{ fontSize: 20, color: "primary.main" }} />
                  Configuration
                </Typography>
                {renderFormFields()}
              </Box>

              {/* Generated Content Editor */}
              {generatedContent && (
                <Fade in={true}>
                  <Box>
                    <Paper
                      sx={{
                        p: 3,
                        borderRadius: 2.5,
                        background:
                          theme.palette.mode === "dark"
                            ? alpha("#0f172a", 0.9)
                            : alpha("#ffffff", 0.95),
                        border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
                        position: "relative",
                        overflow: "hidden",
                        "&:before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: 4,
                          background: generators.find(
                            (g) => g.id === activeGenerator,
                          )?.gradient,
                        },
                      }}
                    >
                      {/* Editor Header */}
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ mb: 2 }}
                      >
                        <Typography variant="subtitle1" fontWeight={600}>
                          AI Generated Content
                        </Typography>
                        <Stack direction="row" spacing={1}>
                          <CustomTooltip title="View Raw Text">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setActiveTab(1);
                                setOpenContentDialog(true);
                              }}
                              sx={{
                                background: alpha(
                                  theme.palette.primary.main,
                                  0.1,
                                ),
                                "&:hover": {
                                  background: alpha(
                                    theme.palette.primary.main,
                                    0.2,
                                  ),
                                },
                              }}
                            >
                              <TextFields fontSize="small" />
                            </IconButton>
                          </CustomTooltip>
                          <CustomTooltip title="Fullscreen">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setActiveTab(0);
                                setOpenContentDialog(true);
                              }}
                              sx={{
                                background: alpha(
                                  theme.palette.primary.main,
                                  0.1,
                                ),
                                "&:hover": {
                                  background: alpha(
                                    theme.palette.primary.main,
                                    0.2,
                                  ),
                                },
                              }}
                            >
                              <Fullscreen fontSize="small" />
                            </IconButton>
                          </CustomTooltip>
                          <CustomTooltip title="Copy">
                            <IconButton
                              size="small"
                              onClick={handleCopy}
                              sx={{
                                background: alpha(
                                  theme.palette.success.main,
                                  0.1,
                                ),
                                "&:hover": {
                                  background: alpha(
                                    theme.palette.success.main,
                                    0.2,
                                  ),
                                },
                              }}
                            >
                              <ContentCopy fontSize="small" />
                            </IconButton>
                          </CustomTooltip>
                        </Stack>
                      </Stack>

                      {/* Formatted Content Display */}
                      <Box
                        sx={{
                          p: 2.5,
                          mb: 3,
                          borderRadius: 2,
                          background: alpha(
                            theme.palette.background.paper,
                            0.5,
                          ),
                          border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                          maxHeight: 400,
                          overflow: "auto",
                          fontFamily:
                            "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
                          fontSize: "0.95rem",
                          lineHeight: 1.7,
                        }}
                      >
                        {formattedContent}
                      </Box>

                      {/* Action Buttons */}
                      <Stack
                        direction="row"
                        spacing={1.5}
                        justifyContent="center"
                        sx={{
                          flexWrap: "wrap",
                          gap: 1,
                        }}
                      >
                        {[
                          {
                            icon: <Save />,
                            label: "Save",
                            action: handleSave,
                            gradient:
                              "linear-gradient(135deg, #44AF69, #2E8B57)",
                          },
                          {
                            icon: <Download />,
                            label: "Download",
                            action: handleDownload,
                            gradient:
                              "linear-gradient(135deg, #4A90E2, #357ABD)",
                          },
                          {
                            icon: <ContentCopy />,
                            label: "Copy",
                            action: handleCopy,
                            gradient:
                              "linear-gradient(135deg, #FFB347, #FFCC33)",
                          },
                          {
                            icon: <Share />,
                            label: "Share",
                            action: () => { },
                            gradient:
                              "linear-gradient(135deg, #9C27B0, #7B1FA2)",
                          },
                        ].map((btn) => (
                          <Button
                            key={btn.label}
                            variant="contained"
                            startIcon={btn.icon}
                            onClick={btn.action}
                            size="small"
                            sx={{
                              borderRadius: 2,
                              textTransform: "none",
                              background: btn.gradient,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              "&:hover": {
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                              },
                            }}
                          >
                            {btn.label}
                          </Button>
                        ))}
                      </Stack>
                    </Paper>
                  </Box>
                </Fade>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Floating Action Button with Working Actions */}
      <SpeedDial
        ariaLabel="Quick Actions"
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          "& .MuiSpeedDial-fab": {
            background: "linear-gradient(135deg, #4A90E2, #357ABD)",
            width: 56,
            height: 56,
            "&:hover": {
              background: "linear-gradient(135deg, #357ABD, #2C6CB0)",
            },
          },
        }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<PostAdd />}
          tooltipTitle="New Project"
          onClick={handleNewProject}
          sx={{
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            "&:hover": {
              background: alpha(theme.palette.primary.main, 0.2),
            },
          }}
        />
        <SpeedDialAction
          icon={<Save />}
          tooltipTitle="Save Content"
          onClick={handleSave}
          sx={{
            background: alpha(theme.palette.success.main, 0.1),
            color: theme.palette.success.main,
            "&:hover": {
              background: alpha(theme.palette.success.main, 0.2),
            },
          }}
        />
        <SpeedDialAction
          icon={<ClearAll />}
          tooltipTitle="Clear All"
          onClick={handleClearAll}
          sx={{
            background: alpha(theme.palette.warning.main, 0.1),
            color: theme.palette.warning.main,
            "&:hover": {
              background: alpha(theme.palette.warning.main, 0.2),
            },
          }}
        />
      </SpeedDial>

      {/* Full Screen Content Dialog */}
      <Dialog
        open={openContentDialog}
        onClose={() => setOpenContentDialog(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 3,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: generators.find((g) => g.id === activeGenerator)
              ?.gradient,
            color: "white",
            py: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Content Preview
          </Typography>
          <IconButton
            onClick={() => setOpenContentDialog(false)}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Tabs for Formatted vs Raw View */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3, pt: 2 }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{ minHeight: 40 }}
          >
            <Tab
              label="Formatted View"
              icon={<TextFields />}
              iconPosition="start"
              sx={{ minHeight: 40, fontSize: "0.875rem" }}
            />
            <Tab
              label="Raw Text"
              icon={<EditNote />}
              iconPosition="start"
              sx={{ minHeight: 40, fontSize: "0.875rem" }}
            />
          </Tabs>
        </Box>

        <DialogContent sx={{ py: 3, px: 3 }}>
          {activeTab === 0 ? (
            // Formatted Content View
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                background: alpha(theme.palette.background.paper, 0.5),
                fontFamily:
                  "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
                fontSize: "1rem",
                lineHeight: 1.7,
                maxHeight: isMobile ? "calc(100vh - 300px)" : 500,
                overflow: "auto",
              }}
            >
              {formattedContent}
            </Box>
          ) : (
            // Raw Text View
            <TextField
              fullWidth
              multiline
              rows={isMobile ? 20 : 25}
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontFamily:
                    "'Inter', 'SF Pro Display', -apple-system, sans-serif",
                  fontSize: "0.95rem",
                  lineHeight: 1.7,
                  border: "none",
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  fontFamily:
                    "'Inter', 'SF Pro Display', -apple-system, sans-serif",
                },
              }}
            />
          )}
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            pt: 2,
          }}
        >
          <Button
            onClick={handleCopy}
            startIcon={<ContentCopy />}
            variant="contained"
            color="primary"
          >
            Copy
          </Button>
          <Button
            onClick={handleDownload}
            startIcon={<Download />}
            variant="contained"
            color="success"
          >
            Download
          </Button>
          <Button
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
            color="info"
          >
            Save
          </Button>
          <Button
            onClick={() => setOpenContentDialog(false)}
            startIcon={<Close />}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Saved Contents Dialog */}
      <Dialog
        open={openSavedDialog}
        onClose={() => setOpenSavedDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(135deg, #1e293b, #0f172a)"
                : "linear-gradient(135deg, #ffffff, #f8fafc)",
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            pb: 2,
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(135deg, #1e293b, #0f172a)"
                : "linear-gradient(135deg, #ffffff, #f8fafc)",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontWeight={600}>
              <History
                sx={{ mr: 1, verticalAlign: "middle", color: "primary.main" }}
              />
              Saved Contents ({savedContents.length})
            </Typography>
            <IconButton
              onClick={() => setOpenSavedDialog(false)}
              size="small"
              sx={{
                color: theme.palette.text.secondary,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.text.secondary, 0.1),
                  color: theme.palette.text.primary,
                },
              }}
            >
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{
            py: 3,
            background: theme.palette.mode === "dark" ? "#0f172a" : "#f8fafc",
          }}
        >
          {savedContents.length === 0 ? (
            <Box
              sx={{
                textAlign: "center",
                py: 8,
                color: "text.secondary",
              }}
            >
              <History
                sx={{
                  fontSize: 60,
                  mb: 2,
                  opacity: 0.3,
                  color: "primary.main",
                }}
              />
              <Typography variant="h6" gutterBottom>
                No saved content yet
              </Typography>
              <Typography variant="body2">
                Generate some content and save it to see it here
              </Typography>
            </Box>
          ) : (
            <List sx={{ pt: 0 }}>
              {savedContents.map((item) => (
                <ListItem
                  key={item.id}
                  sx={{
                    mb: 1.5,
                    p: 2,
                    borderRadius: 2,
                    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    background: alpha(
                      item.color || theme.palette.primary.main,
                      0.03,
                    ),
                    transition: "all 0.2s",
                    "&:hover": {
                      background: alpha(
                        item.color || theme.palette.primary.main,
                        0.08,
                      ),
                      borderColor: alpha(
                        item.color || theme.palette.primary.main,
                        0.3,
                      ),
                      transform: "translateX(4px)",
                    },
                  }}
                  secondaryAction={
                    <Stack direction="row" spacing={0.5}>
                      <CustomTooltip title="View">
                        <IconButton
                          edge="end"
                          aria-label="view"
                          onClick={() => handleViewSaved(item)}
                          size="small"
                          sx={{
                            background: alpha(theme.palette.primary.main, 0.1),
                            color: theme.palette.primary.main,
                            "&:hover": {
                              background: alpha(
                                theme.palette.primary.main,
                                0.2,
                              ),
                              color: theme.palette.primary.dark,
                            },
                          }}
                        >
                          <Visibility fontSize="small" />
                        </IconButton>
                      </CustomTooltip>
                      <CustomTooltip title="Delete">
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => handleDeleteSaved(item.id)}
                          size="small"
                          sx={{
                            background: alpha(theme.palette.error.main, 0.1),
                            color: theme.palette.error.main,
                            "&:hover": {
                              background: alpha(theme.palette.error.main, 0.2),
                              color: theme.palette.error.dark,
                            },
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </CustomTooltip>
                    </Stack>
                  }
                >
                  <ListItemIcon sx={{ minWidth: 44 }}>
                    <Avatar
                      sx={{
                        bgcolor: alpha(
                          item.color || theme.palette.primary.main,
                          0.1,
                        ),
                        color: item.color || theme.palette.primary.main,
                        width: 36,
                        height: 36,
                      }}
                    >
                      {getGeneratorIcon(item.generator)}
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle2" fontWeight={600}>
                        {item.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Box
                          sx={{
                            maxHeight: 60,
                            overflow: "hidden",
                            mb: 0.5,
                            fontFamily: "'Inter', sans-serif",
                            fontSize: "0.85rem",
                            lineHeight: 1.4,
                            color: "text.secondary",
                          }}
                        >
                          {item.formattedContent ||
                            formatGeneratedContent(item.content)}
                        </Box>
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Chip
                            label={item.language}
                            size="small"
                            variant="outlined"
                            sx={{
                              height: 20,
                              fontSize: "0.65rem",
                              borderColor: alpha(
                                theme.palette.primary.main,
                                0.3,
                              ),
                              color: theme.palette.primary.main,
                            }}
                          />
                          <Chip
                            label={item.genre}
                            size="small"
                            variant="outlined"
                            sx={{
                              height: 20,
                              fontSize: "0.65rem",
                              borderColor: alpha(
                                theme.palette.secondary.main,
                                0.3,
                              ),
                              color: theme.palette.secondary.main,
                            }}
                          />
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <AccessTime fontSize="inherit" />
                            {item.timestamp}
                          </Typography>
                        </Stack>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            pt: 2,
            background: theme.palette.mode === "dark" ? "#0f172a" : "#f8fafc",
          }}
        >
          <Button
            onClick={() => {
              localStorage.removeItem("aiBookSavedContents");
              setSavedContents([]);
              showNotification("All saved contents cleared!", "info");
            }}
            color="error"
            startIcon={<Delete sx={{ color: "error.main" }} />}
            disabled={savedContents.length === 0}
            sx={{
              color: "error.main",
              borderColor: "error.main",
              "&:hover": {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                borderColor: "error.dark",
              },
            }}
            variant="outlined"
          >
            Clear All
          </Button>
          <Button
            onClick={() => {
              const dataStr = JSON.stringify(savedContents, null, 2);
              const dataUri =
                "data:application/json;charset=utf-8," +
                encodeURIComponent(dataStr);
              const exportFileDefaultName = `ai-book-saved-contents-${Date.now()}.json`;
              const linkElement = document.createElement("a");
              linkElement.setAttribute("href", dataUri);
              linkElement.setAttribute("download", exportFileDefaultName);
              linkElement.click();
              showNotification("All content exported!", "success");
            }}
            startIcon={<Download />}
            disabled={savedContents.length === 0}
            variant="contained"
            color="primary"
          >
            Export All
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "transparent !important", // Remove default paper background
            boxShadow: "none !important",
          },
        }}
      >
        <Box
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
          }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={notification.severity}
            onClose={() => setNotification({ ...notification, open: false })}
            sx={{
              borderRadius: 2,
              backdropFilter: "blur(10px)",
              backgroundColor: (() => {
                switch (notification.severity) {
                  case "success":
                    return "#2e7d32"; // Dark green
                  case "error":
                    return "#d32f2f"; // Dark red
                  case "warning":
                    return "#ed6c02"; // Dark orange
                  case "info":
                    return "#0288d1"; // Dark blue
                  default:
                    return "#1976d2";
                }
              })(),
              color: "white",
              fontWeight: 500,
              "& .MuiAlert-icon": {
                color: "white !important",
                opacity: 0.9,
              },
              "& .MuiAlert-action": {
                color: "white",
                opacity: 0.8,
                "& .MuiIconButton-root": {
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                },
              },
              // Override any default MUI styles
              "&.MuiAlert-filledSuccess": {
                backgroundColor: "#2e7d32 !important",
              },
              "&.MuiAlert-filledError": {
                backgroundColor: "#d32f2f !important",
              },
              "&.MuiAlert-filledWarning": {
                backgroundColor: "#ed6c02 !important",
              },
              "&.MuiAlert-filledInfo": {
                backgroundColor: "#0288d1 !important",
              },
              // Ensure text is visible
              "& .MuiAlert-message": {
                color: "white",
                fontWeight: 500,
                padding: "8px 0",
              },
            }}
          >
            {notification.message}
          </MuiAlert>
        </Box>
      </Snackbar>
    </Box>
  );
};

export default AIBookWriting;
